import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {AppComponent} from "../../app.component";
import {environment} from "../../../environments/environment";
import {MenuService} from "./app.menu.service";
import {TokenDataProviderService} from "../../core/services/token-data-provider.service";
import {TranslateService} from "@ngx-translate/core";
import {StaticPageRestService} from "../../api/services/static-page.rest.service";
import {StaticPageApiModel} from "../../api/models/static-page.api.model";
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-menu',
  template: `
    <div class="layout-menu-scroll-body">
      <ul class="layout-menu">
        <li app-menuitem *ngFor="let item of model; let i = index;" [item]="item" [index]="i" [root]="true"></li>
      </ul>
    </div>
    <div class="bottom-container width-100" [class.bottom-container--compact]="isMenuScrolled">
      <ul class="layot-topbar-items bottom-container__logout">
        <li class="layout-topbar-action-item">
          <a [routerLink]="['/']" class="flex flex-row justify-content-center align-items-center" pRipple
             (click)="logout($event)">
            <i class="pi pi-power-off" [ngClass]="{'mr-2': !app.isRTL, 'ml-2': app.isRTL}"></i>
            <span>{{ 'shared.inline_menu.logout' | translate }}</span>
          </a>
        </li>
      </ul>
      <div class="bottom-container__meta-shell">
        <hr class="width-100 m-0">
        <div class="bottom-container__meta width-100 px-3 py-2 flex align-items-center gap-5">
          <p-button type="button" (click)="appMenuService.configMenuActive = true" icon="pi pi-cog"
                    styleClass="layout-config-button p-button-icon-only p-button-rounded p-button-outlined p-2">
          </p-button>
          <span>WTG v. {{ version }}</span>
        </div>
      </div>
    </div>
  `
})
export class AppMenuComponent implements OnInit, AfterViewInit, OnDestroy {
  public version: string = environment.version;
  public model: any[] = [];
  public isMenuScrolled = false;
  private subscriptions: Subscription[] = [];
  private menuScrollListener?: () => void;

  constructor(
    private readonly elementRef: ElementRef<HTMLElement>,
    private readonly renderer: Renderer2,
    public app: AppComponent,
    public appMenuService: MenuService,
    private readonly ts: TokenDataProviderService,
    private readonly translate: TranslateService,
    private readonly staticPageRS: StaticPageRestService
  ) {
  }

  ngOnInit() {
    this.loadStaticPages();
    this.subscriptions.push(this.translate.onLangChange.subscribe(() => this.loadStaticPages()));
  }

  ngAfterViewInit(): void {
    const menuContainer = this.elementRef.nativeElement.closest('.layout-menu-container') as HTMLElement | null;
    if (!menuContainer) {
      return;
    }

    const updateScrolledState = (): void => {
      this.isMenuScrolled = menuContainer.scrollTop > 0;
    };

    updateScrolledState();
    this.menuScrollListener = this.renderer.listen(menuContainer, 'scroll', updateScrolledState);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    this.menuScrollListener?.();
  }

  public logout(event: Event): void {
    this.ts.logout();
  }

  private loadStaticPages(): void {
    this.staticPageRS.getNavigation('app_menu').subscribe({
      next: (pages: StaticPageApiModel[]) => {
        this.model = pages.length ? [
          {
            label: this.translate.instant('admin.static_pages.navigation_title'),
            icon: 'pi pi-fw pi-file',
            items: pages.map((page) => ({
              label: page.title,
              icon: this.resolveIcon(page.slug),
              routerLink: [this.staticPageRS.buildPublicRoute(page)]
            }))
          }
        ] : [];
      },
      error: () => {
        this.model = [];
      }
    });
  }

  private resolveIcon(slug: string): string {
    if (slug === 'privacy-policy') {
      return 'pi pi-shield';
    }
    if (slug === 'terms') {
      return 'pi pi-file';
    }

    return 'pi pi-book';
  }
}
